export default class Search {
    constructor() {
        this.searchIcon = document.getElementById("jsSearch");
        this.searchForm = document.getElementById("jsSearchForm");

        if (this.searchIcon && this.searchForm) {
            this.events();
        }
    }

    events() {
        this.searchForm.style.display = "none";

        this.searchIcon.addEventListener("click", this.showForm.bind(this));
    }

    showForm(e) {
        this.searchForm.style.display =
            this.searchForm.style.display === "none" ? "" : "none";
    }
}
